"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVirtualPowerPlant = function IconVirtualPowerPlant(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M24 20.76c6.136 0 11.11 4.974 11.11 11.11S30.136 42.98 24 42.98s-11.11-4.974-11.11-11.11S17.864 20.76 24 20.76m0 2a9.11 9.11 0 1 0 0 18.221 9.11 9.11 0 0 0 0-18.221m.5 7.74L28 29l-6 10 1.5-6.5L20 34l6-10zM27 5c6.728 0 11.965 5.325 12.257 12.11l.01.295.118.013c4.692.595 8.358 4.483 8.605 9.33l.01.281a9.52 9.52 0 0 1-9.474 9.244l-.246-.004h-1.32v-2h1.32v.979l.024-.977c4.137.098 7.576-3.164 7.696-7.248a7.87 7.87 0 0 0-7.498-7.675l-.248-.008-.984-.016v-1.596C37.28 11.732 32.8 7 27.002 7a11.35 11.35 0 0 0-9.726 5.555l-.162.28-.735 1.323-.928-1.194A5.07 5.07 0 0 0 11.576 11a5.1 5.1 0 0 0-5.016 5.114q-.001.37.05.734l.042.24.13.674-.58.364C3.66 19.727 2.083 22.493 2 25.45a9 9 0 0 0 8.784 8.818l.261.002.011 2C5.043 36.3.12 31.5 0 25.442a11 11 0 0 1 4.319-8.44l.272-.202a8 8 0 0 1-.024-.349l-.007-.34C4.553 12.231 7.663 9.064 11.58 9a7.1 7.1 0 0 1 4.292 1.56l.2.167a13.36 13.36 0 0 1 10.592-5.722z"
  })));
};

export { IconVirtualPowerPlant, IconVirtualPowerPlant as default };
